import { CommuterTrafficFeeTypeService } from './commuter-traffic-fee-type.service';
import { CommuterTrafficFeeType } from './commuter-traffic-fee-type.interface';
const service = new CommuterTrafficFeeTypeService();

export interface CommuterTrafficFeeTypeState {
   commuterTrafficFeeTypes: Array<CommuterTrafficFeeType>;
}

const state: CommuterTrafficFeeTypeState = {
   commuterTrafficFeeTypes: [],
};

const getters = {
   commuterTrafficFeeTypes(state: CommuterTrafficFeeTypeState) {
      return state.commuterTrafficFeeTypes;
   },
};

const mutations = {
   SET_COMMUTER_TRAFFIC_FEE_TYPES(state: CommuterTrafficFeeTypeState, commuterTrafficFeeTypes: Array<CommuterTrafficFeeType>) {
      state.commuterTrafficFeeTypes = commuterTrafficFeeTypes;
   },
};

const actions = {
   async getCommuterTrafficFeeTypes(context: any) {
      return await service.getCommuterTrafficFeeTypes().then((response) => {
         context.commit('SET_COMMUTER_TRAFFIC_FEE_TYPES', response);
         response;
      });
   },
};

export default {
   namespaced: true,
   state,
   getters,
   mutations,
   actions,
};
